/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
	appUrl: 'https://groin.le17-45.fr/',
	production: true,
	apiUrl: 'https://api.groin.le17-45.fr'
};
